// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1knh1","header":"styles_header__2zG4o","form":"styles_form__1Jc76"};